import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

/**
 * SectionList: Component to list all the MenuSections
 */
export function SectionList(props) {
  const renderMenu = (menu, key) =>
    React.cloneElement(props.menu, {
      key,
      ...menu,
    });

  return <div className='sectionList'>{props.sections.map(renderMenu)}</div>;
}

SectionList.propTypes = {
  /**
   * List of Sections to render in List
   */
  sections: PropTypes.array.isRequired,
  /**
   * Component to be rendered as MenuItem
   */
  menu: PropTypes.element.isRequired,
};

export {Menu} from './Menu';
